
<template>
<section class="section">
  <div class="columns">
    <div class="column container is-8 main">
      <content-filter v-on:searchClick="searchHandler" :createNewItem="createProduct" :filterGroups="filterGroups" :infoMsg="filterMsg"></content-filter>

      <!-- search results header -->
      <nav v-if="searchingText.length > 0" class="level-left">
        <div class="level-item">   
           <p class="subtitle is-4"> 
             <span>Search results for: {{ searchingText}}</span>
            </p>
        </div>
        <b-tooltip class="level-item" label="Clear search results">    
            <button class="delete" v-on:click="clearSearch">Clear</button>
        </b-tooltip>
      </nav>
      <br>
      
      <div v-for="(item, index) in products" :key="index">
        <product-card :product="item" v-on:edit="editProduct" v-on:delete="deleteProductModal" :action1="'edit'" :action2="'delete'"/>
        <br>
      </div>

      <pagination class="is-centered" :urlBuilder="urlBuilder" 
            v-bind:currentPage="page.pageNumber"
            v-bind:lastPage="page.totalPages"/>

      <loading :active.sync="loading" 
      :can-cancel="false" 
      :is-full-page="false"></loading>
    </div>

    <!--END CONTENT -->
    <product-editor v-if="isEditorVisible" v-on:closeProductEditor="closeProductEditor" 
    :productId="this.productId" :header="productEditorHeader"/>
    <delete-confirmer v-if="isDeleteModalVisible" :text="deleteMsg" :header="deleteHeader" 
    v-on:close="closeProductDeleteWindow" :id="this.productId" v-on:delete="deleteProduct"/>
    
  </div>
  </section>
</template>

<script>
import ProductCard from "../ProductCard";
import ContentFilter from "../ContentFilter";
import AppBreadcrumb from "../AppBreadcrumb";
import ProductEditor from "../ProductEditor";
import DeleteConfirmer from "../DeleteConfirmer";
import Pagination from "vue-bulma-pagination/src/Pagination";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

//import this.HTTP from "../Http";

export default {
  name: "products-vue",
  components: {
    ProductCard,
    AppBreadcrumb,
    ContentFilter,
    ProductEditor,
    DeleteConfirmer,
    Pagination,
    Loading
  },
  data() {
    return {
      products: [],
      isEditorVisible: false,
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this product?",
      deleteMsg: "This product will be losted forever!!!(",
      productId: -1,
      productEditorHeader: "",
      filterGroups: [],

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false
    };
  },
  computed: {
    filterMsg: function() {
      if (this.page.totalItems > 0)
        return "<strong>" + this.page.totalItems + "</strong> products";
      else return "";
    }
  },
  methods: {
    getProducts() {
      this.loading = true;
      let query = "products/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.page.pageNumber + "/" + this.page.pageSize + "/";
      if (
        this.searchingText !== null &&
        this.searchingText !== undefined &&
        this.searchingText.length > 0
      ) {
        query += this.searchingText;
      }

      this.HTTP.get(query)
        .then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    createProduct() {
      this.isEditorVisible = true;
      this.productId = -1; //shouldn't edit
      this.productEditorHeader = "Add new product";
    },
    editProduct(id) {
      this.isEditorVisible = true;
      this.productId = id;
      this.productEditorHeader = "Edit product";
    },
    deleteProductModal(id) {
      this.isDeleteModalVisible = true;
      this.productId = id;
    },
    deleteProduct() {
      this.HTTP.delete(`products/` + this.productId)
        .then(response => {
          this.closeProductDeleteWindow();
        })
        .catch(e => {
          console.log(e);
        });
    },
    closeProductEditor() {
      this.isEditorVisible = false;
      this.getProducts(); //should be optimized!
    },
    closeProductDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getProducts(); //should be optimized!
    },

    //pagination

    urlBuilder(page) {
      return { query: { ...this.$route.query, page } }; // Changing page in location query
    },
    searchHandler(searchingText) {
      this.searchingText = searchingText;
    },

    clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },

    pushUrl() {
      this.$router.push({
        path: "Products",
        query: {
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    }
  },
  created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.HTTP.load(); //.then(() => {
    this.getProducts();
    // });
  },

  watch: {
    $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.searchingText = to.query.search;
      } else {
        //this.pushUrl();
      }

      this.getProducts();
    },
    searchingText: function(val) {
      this.pushUrl();
    },
    page: function(val) {
      this.pushUrl();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/views/Products.Vue